import validationMessages from 'vee-validate/dist/locale/ja';
//citrix.co.jp

const yesNoOptions = [
    {value: "Yes", text: "はい"},
    {value: "No", text: "いいえ"}
]

export default {
    privacyLinkLabel: "プライバシーポリシー",
    privacyLink: '/ja-jp/about/legal/privacy/',
    privacyText: "シトリックスは、",
    privacyText2: "に従ってお客様のデータを処理します。",
    resetText: "表示されている情報がお客様の情報と異なる場合は、",
    resetText2: "して入力し直してください。",
    resetLinkText: "こちらをクリック",
    yes: "はい",
    no: "いいえ",
    submitBtn: {
        "Submit" : "送信",
        "Watch demo" : "送信", //temp Submit
        "Get the kit" : "キットを取得する",
        "Get the eBook" : "e-Bookを取得する",
        "Request a demo": "デモをリクエストする",
        "Request a call": "電話をリクエスト"
    },
    apjPrivacy:{
        title: "個人情報の取扱いについて",
        company: "シトリックス・システムズ・ジャパン株式会社",
        part1: "以下「弊社」といいます。）は、適用のある個人情報の保護に関する法律および",
        linkText: "弊社のプライバシーポリシー",
        part2: "に従って、個人情報の管理・取扱いには十分に注意を払い、厳重にアクセス制限された環境下で保管、利用いたします。 提供いただきました個人情報は、弊社にて厳正に管理し、弊社プライバシーポリシーに定める利用目的以外に転用いたしません。 また、弊社は、弊社プライバシーポリシーに定めるところに従い、個人情報の取扱業務を国内外の事業者に委託し、または、個人情報を弊社グループ内で共同利用し、もしくは国内外の第三者に開示、提供することがあります。 なお、弊社に対して個人情報を提供された場合、弊社プライバシーポリシーの内容に沿った個人情報の取扱いについての同意を弊社に与えたものとみなされます。",
        privacyAccept: "上記およびシトリックスのプライバシーポリシーを確認のうえ、同意します。"
    },
    fields: {
        "AnnualSales": {
            label: "Annual Sales"
        },
        "Company_Self_Reported__c": {
            label: "会社名"
        },
        "department": {
            label: "所属部門",
            options: [
                { value: "Application Management", text: "アプリケーション管理" },
                { value: "Consulting Services", text: "コンサルティングサービス" },
                { value: "Education / Training", text: "教育/トレーニング" },
                { value: "Engineering", text: "エンジニアリング" },
                { value: "Executive Office / Administration", text: "経営企画/管理部門" },
                { value: "Finance / Accounting", text: "財務/会計部門" },
                { value: "Human Resources", text: "人事部門" },
                { value: "Information Technology - Systems", text: "情報システム部門" },
                { value: "Legal", text: "法務" },
                { value: "Marketing / PR", text: "広報/宣伝/調査/マーケティング" },
                { value: "Networking", text: "ネットワーキング" },
                { value: "Operations / Manufacturing", text: "生産/製造" },
                { value: "Pre-Sales / Technical Support", text: "プリセールス/テクニカルサポート" },
                { value: "Project Management", text: "プロジェクト管理" },
                { value: "Purchasing", text: "購買/調達" },
                { value: "Sales / Bus-Corp Development", text: "Sales / Bus-Corp Development" },
                { value: "Security", text: "情報システム（セキュリティ担当）" },
                { value: "Web / Online / E-Business", text: "Web / Online / E-Business" }
            ]
        },
        "Industry_Self_Reported__c": {
            label: "業種",
            options: [
                { value: "E-Commerce", text: "EC/ネット通販" },
                { value: "Art & Membership", text: "アート＆メンバーシップ" },
                { value: "Engineering", text: "エンジニアリング" },
                { value: "Service Provider", text: "サービスプロバイダー" },
                { value: "Business/Personal Services", text: "サービス業" },
                { value: "Technology", text: "テクノロジー" },
                { value: "Real Estate", text: "不動産" },
                { value: "Transportation", text: "交通手段" },
                { value: "Personnel Services", text: "個人サービス" },
                { value: "Government/National-Federal", text: "公務（立法/司法/行政機関）" },
                { value: "Health Care", text: "医療機関" },
                { value: "Government/Local", text: "地方公務（市町村機関）" },
                { value: "Government/State-Province", text: "地方公務（都道府県機関）" },
                { value: "Entertainment", text: "娯楽業" },
                { value: "Household Services", text: "家庭向けサービス" },
                { value: "Business Consulting", text: "専門サービス業（ビジネスコンサルティング）" },
                { value: "Professional Services", text: "専門サービス業（税務/会計）" },
                { value: "Construction and Design", text: "建設/土木" },
                { value: "Publishing/Printing", text: "放送/出版/広告" },
                { value: "Education", text: "教育機関" },
                { value: "Legal", text: "法務" },
                { value: "Retail/Wholesale", text: "流通/商社/卸売小売" },
                { value: "Manufacturing", text: "製造業" },
                { value: "Consumer Packaged Goods", text: "製造業（一般消費財）" },
                { value: "Chemical Manufacturing", text: "製造業（化学/石油/素材）" },
                { value: "Pharmaceuticals", text: "製造業（医薬品）" },
                { value: "Conglomerate", text: "複合企業" },
                { value: "Agriculture", text: "農業" },
                { value: "Telecommunication", text: "通信関連" },
                { value: "Insurance", text: "金融（保険）" },
                { value: "Finance", text: "金融サービス" },
                { value: "Oil and Gas", text: "鉱業（原油・天然ガス）" },
                { value: "Mining - All", text: "鉱業全般" },
                { value: "Utilities", text: "電気/ガス/熱供給/水道業" },
                { value: "Charitable/Non-Profit", text: "非営利団体" },
                { value: "Hospitality", text: "飲食店/宿泊業" }
            ]
        },
        "NumberOfEmployees_Self_Reported__c" : {
            label: "従業員数",
            options: [
                { value: "50", text: "1-50" },
                { value: "500", text: "51-500" },
                { value: "749", text: "501-749" },
                { value: "4999", text: "750-4,999" },
                { value: "19999", text: "5,000-19,999" },
                { value: "20000", text: "20,000+" }
            ]
        },
        "NumberofEmployees__here___atlocation": {
            label: "従業員数",
            options: [
                { value: "5,001 +", text: "5,001人以上" },
                { value: "1,001 to 5,000", text: "1,001人～5,000人" },
                { value: "501 to 1,000", text: "501人～1,000人" },
                { value: "251 to 500", text: "251人～500人" },
                { value: "1 to 250", text: "250人未満" }
            ]
        },
        "Address2": {
            label: "番地"
        },
        "Address3": {
            label: "ビル名"
        },
        "city": {
            label: "市区町村"
        },
        "country": {
            label: "国"
        },
        "email": {
            label: "仕事用の電子メールアドレス"
        },
        "firstName": {
            label: "名（例：太郎）"
        },
        "lastName": {
            label: "姓（例：田中）"
        },
        "phone": {
            label: "電話番号"
        },
        "mobilePhone": {
            label: "Mobile Phone"
        },
        "postalCode": {
            label: "郵便番号"
        },
        "salutation": {
            label: "敬称",
            options: [
                { value: "", text: ""},
                { value: "Dr.", text: "Dr."},
                { value: "Egr. Sig.", text: "Egr. Sig."},
                { value: "Frau", text: "Frau"},
                { value: "Gent.ma Sig.ra", text: "Gent.ma Sig.ra"},
                { value: "Herr", text: "Herr"},
                { value: "Madame", text: "Madame"},
                { value: "Mademoiselle", text: "Mademoiselle"},
                { value: "Miss", text: "Miss"},
                { value: "Monsieur", text: "Monsieur"},
                { value: "Mr.", text: "Mr."},
                { value: "Mrs.", text: "Mrs."},
                { value: "Ms.", text: "Ms."},
                { value: "Professor", text: "Professor"},
                { value: "Señor", text: "Señor"},
                { value: "Señora", text: "Señora"}
            ]
        },
        "state": {
            label: "都道府県"
        },
        "address": {
            label: "住所"
        },
        "Job_Title__c": {
            label: "役職名",
            options: [
                { value: "IT Manager", text: "ITマネージャー" },
                { value: "Assistant", text: "アシスタント" },
                { value: "Architect", text: "システムアーキテクト" },
                { value: "Analyst", text: "システムアナリスト" },
                { value: "Consultant", text: "システムコンサルタント" },
                { value: "System Administrator", text: "システム管理者" },
                { value: "Network Administrator / Engineer", text: "ネットワーク管理者/エンジニア" },
                { value: "Owner / Partner", text: "個人事業主" },
                { value: "Student", text: "学生" },
                { value: "Business Manager", text: "本部長" },
                { value: "C-Level / President / VP", text: "経営者/役員" },
                { value: "Director", text: "部長" },
                { value: "Developer / Programmer", text: "開発者/プログラマー" }
            ]
        },
        "Project_Budget__c": {
            label: "システム投資予算を\n" +
                "確保されていますか？",
            options: [
                { value: "Yes", text: "はい" },
                { value: "No", text: "いいえ" },
                { value: "Unknown", text: "不明" }
            ]
        },
        "Primary_Product_Interest__c": {
            label: "複数ご選択いただけます（５項目まで)"
        },
        "Purchase_Timeframe__c": {
            label: "システムのご導入は\n" +
                "いつ頃を予定\n" +
                "していますか？",
            options: [
                { value: "3 months or less", text: "3か月以内" },
                { value: "4 to 6 months", text: "4～6か月" },
                { value: "7 months or more", text: "7か月以上" },
                { value: "No time frame", text: "未定" },
                { value: "Unknown", text: "不明" }
            ]
        },
        "Email_Blast_OK__c": {
            label: "お客様宛てに当社から電子メールをお送りしてもよろしいですか？",
            options: [
                { value: "Yes", text: "はい" },
                { value: "No", text: "いいえ" }
            ]
        },
        "Direct_Mail_OK__c": {
            label: "May we contact you by mail?",
            options: [
                { value: "Yes", text: "はい" },
                { value: "No", text: "いいえ" }
            ]
        },
        "OK_to_Call__c": {
            label: "お客様宛てに当社からお電話を差し上げてもよろしいですか？",
            options: [
                { value: "Yes", text: "はい" },
                { value: "No", text: "いいえ" }
            ]
        },
        "Preferred_Language__c": {
            label: "Preffered language"
        },
        "Sales_Contact_Requested__c": {
            label: "シトリックスからの連絡に同意する"
        },
        "Comments_6__c":{
            label: "ご質問、お問い合わせ内容をご記入ください。"
        },
        //PrefCenter fields/options
        "Unsubscribed": {
            label: "すべてのマーケティング関係のメール配信を停止する。",
            options: [...yesNoOptions]
        },
        "Marketing_Suspended_30_Days__c": {
            label: "30日間通知を停止する。",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Workspace__c": {
            label: "アプリケーション、デスクトップ、ファイル、モバイルデバイスを含む包括的なデジタルワークスペースを使うことで、お客様はどこにいようと最良の仕事ができるようになります。",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_VirtualAppsDesktops__c": {
            label: "あらゆるデバイスを通じて、あらゆるアプリケーション、デスクトップ、データへのセキュアアクセスを実現できます。",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_NetworkingADC__c": {
            label: "ハイブリッドマルチクラウド環境において、モノリシックベースおよびマイクロサービスベースのアプリケーションデリバリーを管理できます。",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_SDWan__c": {
            label: "ユーザーが必要とする常時オンで高性能のネットワークを提供できます。",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Analytics__c": {
            label: "アナリティクスと知見を通じて、セキュリティ上の脅威やパフォーマンスの異常を検出することで、問題が起こる前にそれらを阻止できます。",
            options: [...yesNoOptions]
        }
    },
    optOut: {
        formTitle: "配信を停止",
        thankyou: "お客様のメール配信に関するご要望は更新されました。誤って変更された場合や、ご自分の配信設定を確認したい場合、いつでも当社の配信設定センターにアクセスしてください。",
        formDescription: "長い間ご購読ありがとうございました。今後も、Citrix.comをご訪問くださるようお願いします。当社では、シトリックスの製品がお客様にとって役立つように、常に新しい機能を追加しています。",

    },
    preferenceCenter: {
        formTitle: "シトリックス配信設定センター",
        thankyou: "<h3>配信解除のご連絡を承りました。</h3><p>お客様の配信要望は更新されました。</p>",
        formDescription: "お客様のメール配信やお知らせに関するご要望は、当社にとって重要なものです。当社は、お客様およびお客様の組織がより良い働き方を推進できるような情報を発信していくことを目指しています。お客様のメール配信に関するご要望を更新することで、お客様が関心のあるシトリックスからの通知を確実に受信できるようになります。",
        labelOne: "お客様に関する情報を教えてください。",
        labelTwo: "どのようなトピックに興味がありますか？",
        labelThree: "どのような方法で通知を受け取りたいですか？",
    },
    validation: validationMessages
}